import { injectable } from 'inversify';
import type { IPanelFacturacionRepository } from '@/domain/repositories/IPanelFacturacionRepository';
import { PanelFacturacion } from '@/domain/entities/PanelFacturacion';

@injectable()
export class MockPanelFacturacionRepository implements IPanelFacturacionRepository {
  private mockPanels: PanelFacturacion[] = [
    PanelFacturacion.create(
      1,
      '2026-01',
      45,
      5,
      2,
      38,
      7,
      125000,
      25000,
      new Date('2026-01-01'),
      new Date('2026-01-31'),
      'Período de enero 2026'
    ),
    PanelFacturacion.create(
      2,
      '2025-12',
      42,
      3,
      1,
      35,
      5,
      110000,
      15000,
      new Date('2025-12-01'),
      new Date('2025-12-31'),
      'Período de diciembre 2025'
    ),
    PanelFacturacion.create(
      3,
      '2025-11',
      40,
      2,
      0,
      38,
      2,
      105000,
      5000,
      new Date('2025-11-01'),
      new Date('2025-11-30'),
      'Período de noviembre 2025'
    ),
  ];

  async getAll(pageNumber?: number, pageSize?: number): Promise<PanelFacturacion[]> {
    await new Promise(resolve => setTimeout(resolve, 300));
    return [...this.mockPanels];
  }

  async getById(id: number): Promise<PanelFacturacion> {
    await new Promise(resolve => setTimeout(resolve, 200));
    const panel = this.mockPanels.find(p => p.id === id);
    if (!panel) {
      throw new Error('Panel not found');
    }
    return panel;
  }
}
